//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { StudentSignupInputItem } from './StudentSignupInputItem';

export class AdditionalStudentSignupInputItem extends StudentSignupInputItem {
    WebsiteBlockID: string | null = null;

    constructor(initializer?: Partial<AdditionalStudentSignupInputItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static override readonly ClassName: string = "AdditionalStudentSignupInputItem";
}
